import React from 'react';

import { useWatch } from 'react-hook-form';

import { MedicationSchema } from '@/models/ConditionModel.ts';
import { GestationalFormWarning } from '@/uiKit/molecules/GestationalFormWarning.tsx';

export const NoInsulinGestationalWarning: React.FC = () => {
  const insulinScheme = useWatch({
    name: 'insulinScheme',
  }) as MedicationSchema | undefined;

  if (insulinScheme !== 'noInsulin') {
    return null;
  }

  return <GestationalFormWarning />;
};
